import * as TypeGraphQL from "type-graphql";
export var StorageProvider;
(function (StorageProvider) {
    StorageProvider["AWS_S3"] = "AWS_S3";
    StorageProvider["GCP_STORAGE"] = "GCP_STORAGE";
    StorageProvider["AZURE_BLOB"] = "AZURE_BLOB";
    StorageProvider["LOCAL"] = "LOCAL";
})(StorageProvider || (StorageProvider = {}));
TypeGraphQL.registerEnumType(StorageProvider, {
    name: "StorageProvider",
    description: undefined,
});
//# sourceMappingURL=StorageProvider.js.map